(function () {
  // Debug toggle for navigation logging (off by default)
  var __DBG_TAPCART_NAV = (window && window.__DBG_TAPCART_NAV) === true;

  // Helper functions for selective double navigation
  function isOnAccount() {
    try { return /^\/account(?:\/|\?|$)/.test(location.pathname); } catch (e) { return false; }
  }

  function isSameOriginOrRelative(url) {
    try {
      if (typeof url !== 'string') return false;
      if (url.startsWith('/')) return true;
      const u = new URL(url, location.origin);
      return u.origin === location.origin;
    } catch { return false; }
  }

  function isInApp() {
    return (
      window.__isTapcart === true ||
      !!(
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.Tapcart
      ) ||
      typeof window.CustomBlockJavascriptInterface !== "undefined" ||
      !!(
        window.Tapcart &&
        window.Tapcart.variables &&
        window.Tapcart.variables.device
      )
    );
  }

  function getCustomScreenPath(id) {
    return "/phoenix-pages/" + id;
  }

  function openNative(destination) {
    try {
      window.Tapcart.action("screen/open", {
        destination: destination,
      });
      return true;
    } catch (e) {
      /* swallow and fallback */
    }
    return false;
  }

  function tryNavigate(key, webFallbackUrl) {
    // Debug logging for navigation attempts
    if (__DBG_TAPCART_NAV) {
      console.log('[tapcart-nav] tryNavigate', { key, webFallbackUrl });
    }

    // Helper function to navigate to web URL
    function navigateToWebUrl(url) {
      if (!url) return false;
      try {
        window.location.href = url;
        // Returning false consumes the original click (prevents default)
        return false;
      } catch (e) {
        return false;
      }
    }

    // If not in app, immediately try web fallback
    if (!isInApp()) {
      return navigateToWebUrl(webFallbackUrl);
    }

    // Get configuration for screen IDs
    var conf = window.__TAPCART_NAV || {};
    var screenId = null;
    if (key === "subscription") screenId = conf.subscription;
    if (key === "library") screenId = conf.library;
    if (key === "review") screenId = conf.review;

    // If no screenId is configured, try web fallback
    if (!screenId) {
      if (__DBG_TAPCART_NAV) {
        console.warn('[tapcart-nav] missing screenId for', key, { webFallbackUrl });
      }
      return navigateToWebUrl(webFallbackUrl);
    }

    // Try native navigation first
    if (__DBG_TAPCART_NAV) {
      console.log('[tapcart-nav] native', { key, screenId });
    }
    var destination = {
      type: "internal",
      url: getCustomScreenPath(screenId),
    };
    var ok = openNative(destination);

    // If native navigation failed, try web fallback
    if (!ok) {
      if (__DBG_TAPCART_NAV) {
        console.log('[tapcart-nav] web-fallback', { key, url: webFallbackUrl });
      }
      return navigateToWebUrl(webFallbackUrl);
    }

    // SPECIAL CASE: Account → Subscription shadow navigation
    if (key === 'subscription' && isOnAccount() && isSameOriginOrRelative(webFallbackUrl)) {
      try { window.location.href = webFallbackUrl; } catch (e) {}
      return false; // consume the click; native + explicit web shadow nav
    }

    // Returning false consumes the original click (prevents default)
    return false;
  }

  window.tapcartNavigation = {
    isInApp: isInApp,
    tryNavigate: tryNavigate,
  };
})();
